"use strict";

exports.__esModule = true;
exports.default = isUndefined;
// Is a given variable undefined?
function isUndefined(obj) {
  return obj === void 0;
}